import { useGroupsContext } from '@fs/zion-tree-groups'
import { type SwrResponse, useSwrRequest } from './useSwrRequest'

type Status = 'SUCCEEDED' | 'FAILED' | 'IN_PROGRESS' | 'INTERRUPTED'

type GedcomData = { fileName: string; uploadDate: string; status: Status; errorCount: number; errorReviewDone: boolean }

type In = {
  fileName: string
  modified: string
  status: Status
  personFailedCount: number
  personFactFailedCount: number
  coupleRelationshipFailedCount: number
  coupleFactFailedCount: number
  parentChildRelationshipFailedCount: number
  parentChildFactFailedCount: number
  sourceFailedCount: number
  sourceAttachFailedCount: number
  sourceTagFailedCount: number
  noteFailedCount: number
  associationRelationshipFailedCount: number
  errorReviewDone: boolean
}

type Out = GedcomData

const transform = ({
  fileName,
  modified,
  status,
  personFailedCount,
  personFactFailedCount,
  coupleRelationshipFailedCount,
  coupleFactFailedCount,
  parentChildRelationshipFailedCount,
  parentChildFactFailedCount,
  sourceFailedCount,
  sourceAttachFailedCount,
  sourceTagFailedCount,
  noteFailedCount,
  associationRelationshipFailedCount,
  errorReviewDone,
}: In): Out => {
  const uploadDate = modified.slice(0, 10) // gets date without time
  const errorCount =
    personFailedCount +
    personFactFailedCount +
    coupleRelationshipFailedCount +
    coupleFactFailedCount +
    parentChildRelationshipFailedCount +
    parentChildFactFailedCount +
    sourceFailedCount +
    sourceAttachFailedCount +
    sourceTagFailedCount +
    noteFailedCount +
    associationRelationshipFailedCount

  return { fileName, uploadDate, status, errorCount, errorReviewDone }
}

// TODO: Currently gedcomData is only available to the owner.

export default function useGedcomData(): SwrResponse<Out> {
  const { currentTreeId, isResearcherGroup, treeDetails } = useGroupsContext()
  const url =
    isResearcherGroup && treeDetails && !treeDetails.hidden
      ? `/service/tree/gedcom/upload/results/errors?treeId=${currentTreeId}`
      : null

  return useSwrRequest<Out, In>(url, undefined, { transform })
}
